export enum BillSubmitAction {
  Approve = 'approve',
  ApproveBulk = 'approveBulk',
  ApproveAndClose = 'approveAndClose',
  Save = 'save',
}
